let data = JSON.parse(localStorage.getItem('viergradMenuItemsList'));
// let data = {
//   selected_lang: 'en_US',
//   available_languages: [],
//   custom_html: `&lt;div class=&quot;teamviewer-link&quot; style=&quot;display: flex; align-items: center; gap; 8px;&quot;&gt;   &lt;img width=&quot;25px&quot; src=&quot;https://mhp-dev.4grd.dev/wp-content/uploads/2024/02/TeamViewer_logo-Icon.svg&quot; /&gt;     &lt;div class=&quot;teamviewer-text&quot;&gt;Team Viewer&lt;/div&gt; &lt;/div&gt;`,
//   search_url: 'http://localhost/kramski/?s={needle}',
//   social_network_label: 'Follow us on',
//   social_networks: {
//     instagram_url: 'https://www.instagram.com/kramski_group',
//     linkedin_url: 'https://www.instagram.com/kramski_group',
//     twitter_url: 'https://www.instagram.com/kramski_group',
//     facebook_url: 'https://www.instagram.com/kramski_group',
//     youtube_url: 'https://www.youtube.com/',
//   },
//   menu_items: [
//     {
//       id: 9,
//       name: 'Sample Page',
//       href: 'http://localhost/kramski/index.php/sample-page/',
//       multiLevel: true,
//       style: 'bold',
//       submenuFirstLevel: [
//         {
//           id: 11,
//           name: 'Submenu item',
//           href: 'https://viergrad.de',
//           target: '_blank',
//         },
//       ],
//       target: '',
//     },
//     {
//       id: 10,
//       name: 'Conimex',
//       href: 'https://www.conimext.co.rs',
//       multiLevel: false,
//       style: 'bold',
//       submenu: [],
//       target: '_blank',
//     },
//   ],
// };
console.log('Data: ', data);

export default data;
